<template>
  <div class="d-flex justify-space-between align-center">
    
    <v-btn v-if="!semSetas" text icon @click="subDate" :disabled="disabled">
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
    
    <v-menu :disabled="disabled" ref="menu" right :close-on-content-click="false" v-model="menu" offset-y max-width="290px" min-width="290px">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" depressed rounded :color="color" :disabled="disabled">{{ dateFormatted }}</v-btn>
      </template>
      <v-date-picker 
        color="primary" 
        locale="pt-BR" 
        v-model="date" 
        no-title
        :type="tipo"
        @input="menu = false"
      >
        <v-btn text rounded @click="setHoje" color="primary">
          <v-icon left>mdi-calendar</v-icon>
          Hoje
        </v-btn>
      </v-date-picker>
    </v-menu>
    
    <v-btn v-if="!semSetas" text icon @click="addDate" :disabled="disabled">
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>

    
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: [String],
        default: null
      },
      disabled: Boolean,
      semSetas: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: 'primary'
      },
      tipo: {
        type: String,
        default: 'date' // 'month' or 'date'
      },
    },

    data: (vm) => ({
      menu: false,
    }),

    methods: {
      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        
        if (this.tipo === 'month') {
          return `${month}/${year}`
        }

        return `${day}/${month}/${year}`
      },

      parseDate(date) {
        if (!date) return null

        if (this.tipo === 'month') {
          return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}`;
        }

        return date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0');
      },

      addDate() {
        const [year, month, day] = this.date.split('-')
        let data = new Date(Number(year), Number(month) - 1, Number(day));

        if (this.tipo === 'month') {
          data = new Date(year, month - 1, 1);
          data.setMonth(data.getMonth() + 1);
        } else {
          data.setDate(data.getDate() + 1);
        }

        this.date = this.parseDate(new Date(data));
      },

      subDate() {
        const [year, month, day] = this.date.split('-')
        let data = new Date(year, month - 1, day);

        if (this.tipo === 'month') {
          data = new Date(year, month - 1, 1);
          data.setMonth(data.getMonth() - 1);
        } else {
          data.setDate(data.getDate() - 1);
        }

        this.date = this.parseDate(new Date(data));
      },

      setHoje() {
        this.date = this.parseDate(new Date());
        this.menu = false;
      }
    },

    computed: {
      date: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      },

      dateFormatted() {
        return this.formatDate(this.date);
      }
    },
  }
</script>

<style scoped>

</style>